export default "__VITE_ASSET__Df2FER8H__"